<!-- <div  id="divLineChart" class="debug"> -->
<div  id="divLineChart" style="height:500px">
</div>